import SkirtingBoardsForm from './SkirtingBoardsForm';

export default SkirtingBoardsForm;